import { Card } from "@/components/ui/card";
import { ProductSection } from "@/components/product/product-section";
import { RouteSeo } from "@/components/seo/route-seo";

export default function LabResults() {
  return (
    <div className="min-h-screen">
      <RouteSeo
        title="Liquid Stretch Lab Results | Certificate of Analysis"
        description="View the Liquid Stretch Certificate of Analysis and lab summary for First Light Harvest."
        path="/lab-results"
        type="article"
      />
      <section className="py-16 pt-24">
        <div className="container mx-auto px-4">
          <Card className="max-w-4xl mx-auto p-6">
            <h1 className="text-3xl font-bold text-center mb-8">Certificate of Analysis</h1>
            <p className="mb-6 text-center text-gray-700">
              Lab report for Liquid Stretch First Light Harvest, the double-sized 4 oz bottle currently available for purchase.
            </p>
            <div className="flex justify-center">
              <img 
                src="/COA - Pure Relief.webp"
                alt="Liquid Stretch First Light Harvest Certificate of Analysis"
                className="max-w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </Card>
        </div>
      </section>

      <ProductSection />
    </div>
  );
}
